import { render, staticRenderFns } from "./ConfirmForm.vue?vue&type=template&id=454451ad&scoped=true"
import script from "./ConfirmForm.vue?vue&type=script&lang=ts"
export * from "./ConfirmForm.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmForm.vue?vue&type=style&index=0&id=454451ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454451ad",
  null
  
)

export default component.exports